<template>
  <el-main class="page-content-margin-unset">
    <!-- 编辑 -->
    <h3>基本信息</h3>
    <div class="detail">
      <div
        class="img"
        v-if="!body.avatar">暂无头像</div>
      <img
        v-else
        class="img"
        :src="imgDomain + body.avatar"
        alt="">
      <el-form
        :inline="false"
        status-icon
        label-position="left"
        label-width="120px"
        class="demo-ruleForm">
        <el-form-item
          class="dk-input"
          label="用户昵称:">
          <span>{{ body.name }}</span>
        </el-form-item>
        <el-form-item
          class="dk-input"
          label="积分ID">
          <span>{{ body.invite_code }}</span>
        </el-form-item>
        <el-form-item
          class="dk-input"
          label="手机号">
          <span>{{ body.mobile }}</span>
        </el-form-item>
        <el-form-item
          class="dk-input"
          label="积分余额">
          <span v-if="!showInput">{{ body.point }}</span>
          <el-input
            v-else
            class="dk-input"
            v-model="pointBody.point"/>
          <el-button
            type="primary"
            size="mini"
            @click="event().onChangePointClick()">修改积分</el-button>
        </el-form-item>
        <el-form-item
          class="dk-input"
          label="注册时间">
          <span>{{ body.create_time }}</span>
        </el-form-item>
        <el-form-item
          label="积分明细">
          <el-button
            type="primary"
            @click="event().onPointDetailClick()">查看明细</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-main>
</template>

<script>
import { imgDomain } from '../../configs/env'
import { getUserDetail, changePoint } from '../../api/user'

export default {
  data() {
    return {
      imgDomain,
      body: {
      },
      pointBody: {},
      showInput: false,
    };
  },
  created() {
    this.network().getUserDetail()
  },
  methods: {
    event() {
      return {
        onBackClick: () => {
          this.$router.go(-1)
        },
        onPointDetailClick: () => {
          this.$router.push({ path: 'point-detail', query: { uuid: this.$route.query.uuid } })
        },
        onChangePointClick: () => {
          if (this.showInput) {
            this.network().changePoint()
            return
          }
          this.showInput = true
          this.pointBody = this.body
        },
      }
    },
    network() {
      return {
        getUserDetail: async () => {
          const { status, data } = await getUserDetail(this.$route.query.uuid)
          if (status !== 200) return
          this.body = data
        },
        changePoint: async () => {
          if (!this.handler().verifyInput()) return
          const { status } = await changePoint(this.pointBody)
          if (status !== 200) return
          this.network().getUserDetail()
          this.$notify({
            title: '修改积分成功',
            message: '修改用户积分成功',
            type: 'success',
          });
          this.showInput = false
        },
      }
    },
    handler() {
      return {
        verifyInput: () => {
          if (!this.pointBody.point) {
            this.$message({
              message: '请输入积分',
              type: 'warning',
            })
            return false
          }
          if (!Number(this.pointBody.point)) {
            this.$message({
              message: '请输入数字',
              type: 'warning',
            })
            return false
          }
          return true
        },
      }
    },
  },
  components: {
  },
};
</script>

<style scoped lang="scss">
.detail{
  display: flex;
}
.img{
  min-width: 148px;
  height: 148px;
  border-radius: 6px;
  border: 1px solid #c0ccda;
  margin: 0 20px 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/user/detail.vue